var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_844_892",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 65
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 10,
    fill: "#272727"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_844_892)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.9517,
    cy: 41.9512,
    r: 22.9309,
    transform: "rotate(-75 41.9517 41.9512)",
    fill: "url(#paint0_linear_844_892)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8843,
    cy: 23.1012,
    r: 22.9309,
    transform: "rotate(-75 22.8843 23.1012)",
    fill: "url(#paint1_linear_844_892)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8843,
    cy: 23.1012,
    r: 22.9309,
    transform: "rotate(-75 22.8843 23.1012)",
    fill: "url(#paint2_linear_844_892)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.9517,
    cy: 41.9512,
    r: 22.9309,
    transform: "rotate(-75 41.9517 41.9512)",
    fill: "url(#paint3_linear_844_892)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_844_892",
    x1: 59.673,
    y1: 11.7165,
    x2: 25.547,
    y2: 68.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422FB9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_844_892",
    x1: 45.6381,
    y1: 17.0894,
    x2: -8.14783,
    y2: 31.5013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE79C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004871",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_844_892",
    x1: 45.6381,
    y1: 17.0894,
    x2: -8.14783,
    y2: 31.5013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE79C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004871",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_844_892",
    x1: 59.673,
    y1: 11.7165,
    x2: 25.547,
    y2: 68.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422FB9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422FB9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9224f00f8e708071d3d96245f9e006d9.svg";
export { ForwardRef as ReactComponent };